import { ApexUIProvider, theme } from '@apex/component-library'
import { ChakraProvider } from '@chakra-ui/react'
import { OktaAuth } from '@okta/okta-auth-js'
import { Security } from '@okta/okta-react'
import React from 'react'
import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { OKTA_CONFIG } from './constants/okta'
import App from './containers/App'
import { AuthProvider } from './contexts/auth/AuthContext'
import './index.less'
import * as serviceWorker from './serviceWorker'
import configureStore from './store'
import { loadIntlMessages } from './utils'
import ReactQueryProvider from './Providers/ReactQueryProvider'
import { startRum } from './utils/datadog'

startRum()

const store = configureStore()
const oktaAuth = new OktaAuth(OKTA_CONFIG)
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Security oktaAuth={oktaAuth}>
        <ReactQueryProvider>
          <IntlProvider {...loadIntlMessages()}>
            <AuthProvider>
              <ChakraProvider theme={theme}>
                <ApexUIProvider>
                  <BrowserRouter basename='/accountsV2'>
                    <App />
                  </BrowserRouter>
                </ApexUIProvider>
              </ChakraProvider>
            </AuthProvider>
          </IntlProvider>
        </ReactQueryProvider>
      </Security>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
////
